import { DeductibleValue } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Deductible";
import { TextManager } from "Components/TextContext";
import { ShortTitle } from "Components/TextContext/commonComponentEnums";
import { AnimalProduct } from "Store/interfaces/products/checkout/riskProducts/AnimalProduct";
import { humanReadableDate } from "Utils/dateUtils";
import React from "react";
import { ProductDetail } from "../../interface";

export const animalDetailsList = (
  product: AnimalProduct,
  urls: Record<string, string>,
): ProductDetail[] => {
  const { applicableTermsAnimal } = urls;

  const { getText } = TextManager;

  return [
    {
      name: getText(ShortTitle.DEDUCTIBLE),
      value: (
        <a href={applicableTermsAnimal} target="_blank" rel="noreferrer">
          {<DeductibleValue value={"??"} />}
        </a>
      ),
    },
    {
      name: getText("animalform.shorttitle.animaldateofbirth"),
      value: humanReadableDate(new Date(product.dateOfBirth)),
    },

    {
      name: getText("animalform.shorttitle.injuries"),
      value: product.damageCountRecentYears ?? 0,
      hidden: product.coverageAmountVet === 0,
    },
    {
      name: getText("animalform.shorttitle.injuryyear"),
      value: product.yearOfLastDamage,
      hidden:
        product.damageCountRecentYears === 0 || product.coverageAmountVet === 0,
    },
    {
      name: getText(ShortTitle.ISSUE_DATE),
      value: product.issueDate
        ? humanReadableDate(new Date(product.issueDate))
        : "",
      hidden: !product.issueDate,
    },
  ];
};
